var React = require('react');

function NoMarca (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"bridgestone"),React.createElement("desc",{"key":1},"Neumáticos bridgestone"),React.createElement("g",{"id":"Bridgestone_color","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("rect",{"x":"0","y":"0","width":"122","height":"48"}))]);
}

NoMarca.defaultProps = {"width":"122px","height":"48px","viewBox":"0 0 122 48","version":"1.1"};

module.exports = NoMarca;

NoMarca.default = NoMarca;
